import { Link } from 'react-router-dom';

import { ListItem, ListItemIcon, ListItemText, Box } from '@mui/material';
import {
  Settings as SettingsIcon,
  MeetingRoom as MeetingRoomIcon,
  People as PeopleIcon,
  ManageAccounts as ManageAccountsIcon,
  Grass,
  Pets,
  QueryStats,
} from '@mui/icons-material';

import colors from '../../assets/colors';

function ListItemLink(props) {
  return <ListItem button component={Link} {...props} />;
}

export const mainListItems = (isAdmin) => {
  return (
    <Box>
      {!isAdmin && (
        <ListItemLink
          to="/dashboard/multiple-clients"
          sx={{
            marginTop: '3vh',
            marginBottom: 1,
          }}
        >
          <ListItemIcon>
            <PeopleIcon sx={{ color: colors.white }} />
          </ListItemIcon>

          <ListItemText primary="Klienci" sx={{ color: colors.white }} />
        </ListItemLink>
      )}

      {!isAdmin && (
        <ListItemLink
          to="/dashboard/parameters-plants"
          sx={{
            marginTop: 1,
            marginBottom: 1,
          }}
        >
          <ListItemIcon>
            <Grass sx={{ color: colors.white }} />
          </ListItemIcon>

          <ListItemText
            primary="Wskaźniki roślinne"
            sx={{ color: colors.white }}
          />
        </ListItemLink>
      )}

      {!isAdmin && (
        <ListItemLink
          to="/dashboard/parameters-animals"
          sx={{
            marginTop: 1,
            marginBottom: 1,
          }}
        >
          <ListItemIcon>
            <Pets sx={{ color: colors.white }} />
          </ListItemIcon>

          <ListItemText
            primary="Wskaźniki zwierzęce"
            sx={{ color: colors.white }}
          />
        </ListItemLink>
      )}

      {!isAdmin && (
        <ListItemLink
          to="/dashboard/simulation"
          sx={{
            marginTop: 1,
            marginBottom: '40vh',
          }}
        >
          <ListItemIcon>
            <QueryStats sx={{ color: colors.white }} />
          </ListItemIcon>

          <ListItemText primary="Symulacja" sx={{ color: colors.white }} />
        </ListItemLink>
      )}

      {isAdmin && (
        <ListItemLink
          to="/dashboard/permissions-management"
          sx={{ marginTop: '3vh', marginBottom: '55vh' }}
        >
          <ListItemIcon>
            <ManageAccountsIcon sx={{ color: colors.white }} />
          </ListItemIcon>

          <ListItemText
            primary="Zarządzaj uprawnieniami"
            sx={{ color: colors.white }}
          />
        </ListItemLink>
      )}
    </Box>
  );
};

export const logoutListItems = (
  <>
    <ListItemLink
      to="/account-settings"
      sx={{ marginTop: '2vh', marginBottom: '2vh' }}
    >
      <ListItemIcon>
        <SettingsIcon sx={{ color: colors.white }} />
      </ListItemIcon>
      <ListItemText primary="Ustawienia" sx={{ color: colors.white }} />
    </ListItemLink>

    <ListItemLink to="/logout" sx={{ marginTop: '2vh', marginBottom: '2vh' }}>
      <ListItemIcon>
        <MeetingRoomIcon sx={{ color: colors.white }} />
      </ListItemIcon>
      <ListItemText primary="Wyloguj" sx={{ color: colors.white }} />
    </ListItemLink>
  </>
);
